module.exports = {
      id: "ic-trend-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#ic-trend-usage",
      toString: function () {
        return this.url;
      }
    }